export const MailProConstants = {
    newMailing: "newMailing",
    isNewProperty: "isNewProperty",
    newAnniversary: "newAnniversary",
};
